import { render, staticRenderFns } from "./ChatOptions.vue?vue&type=template&id=022f860e&scoped=true&"
import script from "./ChatOptions.vue?vue&type=script&lang=js&"
export * from "./ChatOptions.vue?vue&type=script&lang=js&"
import style0 from "./ChatOptions.vue?vue&type=style&index=0&id=022f860e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022f860e",
  null
  
)

export default component.exports